export default {
  FLEET_PLAYLIST_ID: 'PL-jegeqmkfJ9eWnLj1HNlXORqOqLvNZCD',
};
